// @generated by protoc-gen-connect-query v1.4.1 with parameter "target=ts"
// @generated from file no/jotta/openapi/login/v1/login.v1.proto (package no.jotta.openapi.login.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { MethodKind } from "@bufbuild/protobuf";
import { CheckPasswordResetRequest, CheckPasswordResetResponse, ConfirmDeviceLoginRequest, ConfirmDeviceLoginResponse, EmailLoginRequest, EmailLoginResponse, ExchangeInstallationCodeRequest, ExchangeInstallationCodeResponse, FederatedLoginRequest, FederatedLoginResponse, GetLoginRequest, GetLoginResponse, PhoneNumberLoginRequest, PhoneNumberLoginResponse, ResetPasswordRequest, ResetPasswordResponse, StartDeviceLoginRequest, StartDeviceLoginResponse, StartPasswordResetRequest, StartPasswordResetResponse } from "./login.v1_pb.js";
import { PingRequest, PingResponse } from "../../ping_pb.js";
/**
 * @generated from rpc no.jotta.openapi.login.v1.LoginService.GetLogin
 */
export const getLogin = {
    localName: "getLogin",
    name: "GetLogin",
    kind: MethodKind.Unary,
    I: GetLoginRequest,
    O: GetLoginResponse,
    service: {
        typeName: "no.jotta.openapi.login.v1.LoginService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.login.v1.LoginService.StartDeviceLogin
 */
export const startDeviceLogin = {
    localName: "startDeviceLogin",
    name: "StartDeviceLogin",
    kind: MethodKind.Unary,
    I: StartDeviceLoginRequest,
    O: StartDeviceLoginResponse,
    service: {
        typeName: "no.jotta.openapi.login.v1.LoginService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.login.v1.LoginService.ConfirmDeviceLogin
 */
export const confirmDeviceLogin = {
    localName: "confirmDeviceLogin",
    name: "ConfirmDeviceLogin",
    kind: MethodKind.Unary,
    I: ConfirmDeviceLoginRequest,
    O: ConfirmDeviceLoginResponse,
    service: {
        typeName: "no.jotta.openapi.login.v1.LoginService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.login.v1.LoginService.FederatedLogin
 */
export const federatedLogin = {
    localName: "federatedLogin",
    name: "FederatedLogin",
    kind: MethodKind.Unary,
    I: FederatedLoginRequest,
    O: FederatedLoginResponse,
    service: {
        typeName: "no.jotta.openapi.login.v1.LoginService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.login.v1.LoginService.EmailLogin
 */
export const emailLogin = {
    localName: "emailLogin",
    name: "EmailLogin",
    kind: MethodKind.Unary,
    I: EmailLoginRequest,
    O: EmailLoginResponse,
    service: {
        typeName: "no.jotta.openapi.login.v1.LoginService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.login.v1.LoginService.PhoneNumberLogin
 */
export const phoneNumberLogin = {
    localName: "phoneNumberLogin",
    name: "PhoneNumberLogin",
    kind: MethodKind.Unary,
    I: PhoneNumberLoginRequest,
    O: PhoneNumberLoginResponse,
    service: {
        typeName: "no.jotta.openapi.login.v1.LoginService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.login.v1.LoginService.StartPasswordReset
 */
export const startPasswordReset = {
    localName: "startPasswordReset",
    name: "StartPasswordReset",
    kind: MethodKind.Unary,
    I: StartPasswordResetRequest,
    O: StartPasswordResetResponse,
    service: {
        typeName: "no.jotta.openapi.login.v1.LoginService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.login.v1.LoginService.CheckPasswordReset
 */
export const checkPasswordReset = {
    localName: "checkPasswordReset",
    name: "CheckPasswordReset",
    kind: MethodKind.Unary,
    I: CheckPasswordResetRequest,
    O: CheckPasswordResetResponse,
    service: {
        typeName: "no.jotta.openapi.login.v1.LoginService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.login.v1.LoginService.ResetPassword
 */
export const resetPassword = {
    localName: "resetPassword",
    name: "ResetPassword",
    kind: MethodKind.Unary,
    I: ResetPasswordRequest,
    O: ResetPasswordResponse,
    service: {
        typeName: "no.jotta.openapi.login.v1.LoginService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.login.v1.LoginService.ExchangeInstallationCode
 */
export const exchangeInstallationCode = {
    localName: "exchangeInstallationCode",
    name: "ExchangeInstallationCode",
    kind: MethodKind.Unary,
    I: ExchangeInstallationCodeRequest,
    O: ExchangeInstallationCodeResponse,
    service: {
        typeName: "no.jotta.openapi.login.v1.LoginService"
    }
};
/**
 * Safe noop for testing purposes
 *
 * @generated from rpc no.jotta.openapi.login.v1.LoginService.Ping
 */
export const ping = {
    localName: "ping",
    name: "Ping",
    kind: MethodKind.Unary,
    I: PingRequest,
    O: PingResponse,
    service: {
        typeName: "no.jotta.openapi.login.v1.LoginService"
    }
};
